import React, { useMemo } from 'react';
import { SystemInformation } from './SystemInformation';
import { NetworkAdapters } from './NetworkAdapters';
import { StorageInformation } from './StorageInformation';

export const InventoryDrawerDetails = ({ record }) => {
    return (
        <>
            <SystemInformation record={record} />
            <NetworkAdapters record={record} />
            <StorageInformation record={record} />
        </>
    );
};
